import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import { ConsentBanner } from "@/components/site/ConsentBanner";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Problem } from "@/components/site/Problem";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { Founders } from "@/components/site/Founders";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function Home() {
  return (
    <div className="min-h-screen overflow-x-clip bg-[var(--stone)]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Services />
        <Process />
        <Founders />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
      <ConsentBanner />
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
